<template>
    <div class="card rounded-16">
        <div class="card-header bg-grey p-2 d-flex align-items-center gap-2 rounded-top">
            <b class="text-16">Extras</b>
        </div>
        <div class="card-body">
            <services :basket="basket" :services="services"></services>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['services', 'basket'],
        data() {
            return {
                service: [],
                serviceExplainedModalOpen: false
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>